import axios from "axios";

/**
 * Gets all Contract Holder performance data
 * @returns {Promise<axios.AxiosResponse<ContractHolderPerformanceRating[]>>}
 */
export function getAllContractHolderPerformances() {
  return axios.get("/sewppublic/chperformance/list");
}